import React from 'react';

import Text from '~/components/core/TextComponents/Text';
import cn from '~/Utils/cn';

import { TEXTS } from '../texts';

/** One grid template shared by the header and every row so the columns line up. The leading
 *  24px track is the drag handle; the trailing 90px is the actions menu. Sub Organizations is a
 *  conditional track, hence the two variants rather than a single string. */
export const gridClassFor = (showSubOrgColumn: boolean): string =>
  showSubOrgColumn
    ? 'grid grid-cols-[24px_2fr_1.5fr_1.5fr_2fr_2fr_80px_90px] items-center gap-8'
    : 'grid grid-cols-[24px_2fr_1.5fr_2fr_2fr_80px_90px] items-center gap-8';

interface MoiAssignmentRulesTableHeaderProps {
  showSubOrgColumn: boolean;
}

const MoiAssignmentRulesTableHeader: React.FC<MoiAssignmentRulesTableHeaderProps> = ({ showSubOrgColumn }) => {
  const headings = [
    '',
    TEXTS.COLUMN_NAME,
    ...(showSubOrgColumn ? [TEXTS.COLUMN_SUB_ORGANIZATIONS] : []),
    TEXTS.COLUMN_LOB,
    TEXTS.COLUMN_MOI_METHODS,
    TEXTS.COLUMN_ASSIGNEE,
    TEXTS.COLUMN_ENABLE,
    TEXTS.COLUMN_ACTIONS,
  ];

  return (
    <div className={cn(gridClassFor(showSubOrgColumn), 'border-0 border-b border-solid border-slate-400 pb-8')}>
      {headings.map((heading, index) => (
        <Text
          // Headings are fixed and the empty drag-handle slot repeats no label, so index keys
          // are stable here.
          key={`${heading}-${index}`}
          variant={Text.VARIANTS.XS}
          weight={Text.WEIGHTS.SEMI_BOLD}
          colorVariant={Text.COLOR_VARIANTS.SECONDARY}
        >
          {heading}
        </Text>
      ))}
    </div>
  );
};

export default MoiAssignmentRulesTableHeader;
